import React, { Component } from 'react';
import { motion } from 'framer-motion';
import StarStory from '../components/StarStory';
import AnimatedCounter from '../components/AnimatedCounter';
const ThredUpPage = () => {
  return <div className="bg-white min-h-screen" data-id="element-539">
      <div className="container mx-auto px-4 py-16" data-id="element-540">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row items-center md:items-start gap-6 mb-12" data-id="element-541">
          <img src="https://logo.clearbit.com/thredup.com" alt="ThredUp logo" className="w-24 h-24 object-contain" data-id="element-542" />
          <div data-id="element-543">
            <motion.h1 className="text-4xl font-bold text-gray-800 mb-2" initial={{
            opacity: 0.5
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.5
          }} data-id="element-544">
              Director of Growth at ThredUp
            </motion.h1>
            <motion.p className="text-xl text-gray-700 mb-4" initial={{
            opacity: 0.5
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} data-id="element-545">
              2014 — 2017
            </motion.p>
            <motion.div className="bg-gray-100 p-4 rounded-lg" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} data-id="element-546">
              <p className="text-gray-700" data-id="element-547">
                <span className="font-bold" data-id="element-548">Context:</span> Scaling toward IPO;
                raised $81M in Series D+E during tenure.
              </p>
            </motion.div>
          </div>
        </div>
        {/* STAR Stories */}
        <StarStory title="Pricing Optimization Engine" situation="ThredUp's resale pricing system was static and failed to optimize conversion vs. inventory turnover. Customers hesitated at higher price points, while low turnover hurt liquidity." task="I had to re-architect pricing to balance conversion, new customer growth, and stockthrough." action="We built a rules-based optimization engine layered with machine learning. Inputs: demand elasticity, category velocity, seller expectations. I led the cross-functional effort, designing experiments across 200K SKUs weekly." result="Conversion rate improved by +17%, inventory turnover accelerated by 1.8x, and customer acquisition scaled 10x. This pricing foundation supported ThredUp's fundraising rounds ($81M)." imageUrl="https://via.placeholder.com/600x400?text=ThredUp+Pricing+Dashboard" imageAlt="Screenshot of ThredUp pricing dashboard" animationComponent={<div className="bg-white p-6 rounded-lg shadow-md" data-id="element-550">
              <h4 className="text-lg font-bold mb-4 text-center" data-id="element-551">
                Pricing Performance
              </h4>
              <div className="flex justify-between items-center mb-2" data-id="element-552">
                <span className="text-gray-700" data-id="element-553">Conversion Rate:</span>
                <div className="flex items-center" data-id="element-554">
                  <span className="text-gray-700 mr-1" data-id="element-555">+</span>
                  <AnimatedCounter start={0} end={17} suffix="%" data-id="element-556" />
                </div>
              </div>
              <div className="flex justify-between items-center mb-2" data-id="element-557">
                <span className="text-gray-700" data-id="element-558">Inventory Turnover:</span>
                <div className="flex items-center" data-id="element-559">
                  <span className="text-gray-500 mr-2" data-id="element-560">1x</span>
                  <span className="text-gray-700 mx-1" data-id="element-561">→</span>
                  <AnimatedCounter start={1} end={1.8} suffix="x" decimals={1} data-id="element-562" />
                </div>
              </div>
            </div>} data-id="element-549" />
        <StarStory title="Conversion Optimization" situation="First-visit conversion lagged at just 1.4%. Users browsed but rarely bought." task="I had to increase first-purchase conversion without ballooning CAC." action="I introduced curated Outfit Recommendations, dynamic merchandising, and personalized ad retargeting. We integrated with Facebook and Pinterest APIs for custom creative. I also streamlined checkout flow from 6 → 3 steps." result="First-visit conversion lifted from 1.4% → 3.6% (2.5x). Customer acquisition scaled 10x." imageUrl="https://via.placeholder.com/600x400?text=ThredUp+Homepage" imageAlt="ThredUp homepage with Outfit Builder" animationComponent={<div className="bg-white p-6 rounded-lg shadow-md" data-id="element-564">
              <h4 className="text-lg font-bold mb-4 text-center" data-id="element-565">
                Conversion Lift
              </h4>
              <div className="flex justify-between items-center mb-2" data-id="element-566">
                <span className="text-gray-700" data-id="element-567">First-Visit Conversion:</span>
                <div className="flex items-center" data-id="element-568">
                  <span className="text-gray-500 mr-2" data-id="element-569">1.4%</span>
                  <span className="text-gray-700 mx-1" data-id="element-570">→</span>
                  <AnimatedCounter start={1.4} end={3.6} suffix="%" decimals={1} data-id="element-571" />
                </div>
              </div>
              <div className="flex justify-between items-center" data-id="element-572">
                <span className="text-gray-700" data-id="element-573">Improvement:</span>
                <AnimatedCounter start={1} end={2.5} suffix="x" decimals={1} data-id="element-574" />
              </div>
            </div>} data-id="element-563" />
        <StarStory title="Referral & Paid Growth" situation="ThredUp needed cheap, scalable growth channels." task="Build referral + paid ad systems that could scale efficiently." action="We launched $10-$10 referral and famous $0.99 sale campaigns. I also built an internal ad-tech system to auto-optimize budgets across Facebook, Pinterest, Yahoo." result="Referrals became 22% of new customer volume. Paid campaigns achieved 4.2x ROAS. Together, these channels added millions in monthly GMV." imageUrl="https://via.placeholder.com/600x400?text=Referral+Campaign" imageAlt="Referral campaign ad creative" animationComponent={<div className="bg-white p-6 rounded-lg shadow-md" data-id="element-576">
              <h4 className="text-lg font-bold mb-4 text-center" data-id="element-577">
                Growth Channels
              </h4>
              <div className="flex justify-between items-center mb-2" data-id="element-578">
                <span className="text-gray-700" data-id="element-579">Referral Contribution:</span>
                <AnimatedCounter start={0} end={22} suffix="%" data-id="element-580" />
              </div>
              <div className="flex justify-between items-center" data-id="element-581">
                <span className="text-gray-700" data-id="element-582">Paid ROAS:</span>
                <AnimatedCounter start={1} end={4.2} suffix="x" decimals={1} data-id="element-583" />
              </div>
              <div className="mt-4 flex justify-center" data-id="element-584">
                <motion.div className="w-12 h-12 rounded-full flex items-center justify-center bg-[#0FB9B1] text-white" animate={{
            rotate: 360
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'linear'
          }} data-id="element-585">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-586">
                    <path d="M12 2L15 8H9L12 2Z" fill="white" data-id="element-587" />
                    <path d="M12 22L9 16H15L12 22Z" fill="white" data-id="element-588" />
                    <path d="M2 12L8 9V15L2 12Z" fill="white" data-id="element-589" />
                    <path d="M22 12L16 15V9L22 12Z" fill="white" data-id="element-590" />
                  </svg>
                </motion.div>
              </div>
            </div>} data-id="element-575" />
        {/* Testimonial */}
        <motion.div className="mt-16 bg-gray-100 p-8 rounded-lg" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-591">
          <p className="text-xl text-gray-700 italic mb-4" data-id="element-592">
            "Aakash was the driving force behind our 10x customer acquisition,
            fueling our $81M Series D+E."
          </p>
          <p className="text-gray-800 font-bold" data-id="element-593">— James Reinhart, CEO</p>
        </motion.div>
      </div>
    </div>;
};
export default ThredUpPage;